import { makeStyles } from "@material-ui/core";
import { whiteGrey, white } from "../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  mainForm: {
    backgroundColor: white,
    padding: "30px 60px",
    [down("sm")]: {
      padding: "30px 40px",
    },
    [down("xs")]: {
      padding: "25px 10px",
    },
  },
  secondaryForm: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    backgroundColor: whiteGrey,
    padding: "40px",
    [down("sm")]: {
      padding: "30px 40px",
      backgroundColor: white,
    },
    [down("xs")]: {
      padding: "25px 10px",
      margin: "0 10px",
      borderRadius: "10px",
    },
  },
  formHeader: {
    position: "relative",
    [down("xs")]: {
      "& h1": {
        fontSize: "19px",
      },
    },
  },
  travelCareContainer: {
    backgroundColor: whiteGrey,
    padding: "40px",
    borderRadius: "20px",
  },
  ticketIconWrapper: {
    height: "84px",
    width: "84px",
    borderRadius: "50%",
    backgroundColor: white,
  },
  fullWidth: {
    width: "100%",
    "& .MuiSwitch-root": {
      marginLeft: 0,
    },
  },
  subtitle: {
    fontSize: "14px",
    "& a": {
      marginLeft: "8px",
    },
  },
  headerText: {
    width: "100%",
    [down("xs")]: {
      width: "70%",
    },
  },
  ticketCareBox: {
    [down("sm")]: {
      background: whiteGrey,
      padding: "35px 19px",
      borderRadius: "10px",
    },
  },
}));

export default useStyles;
